// Import model
import { StartContactAppointmentSendUpcomingAppointmentReminderRequest } from '../models/StartContactAppointmentSendUpcomingAppointmentReminderRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAppointmentSendUpcomingAppointmentReminderRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAppointmentSendUpcomingAppointmentReminderRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAppointmentSendUpcomingAppointmentReminderRequest instance
   */
  static deserialize(json: string): StartContactAppointmentSendUpcomingAppointmentReminderRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAppointmentSendUpcomingAppointmentReminderRequest instance
   */
  static fromObject(obj: any): StartContactAppointmentSendUpcomingAppointmentReminderRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAppointmentSendUpcomingAppointmentReminderRequest');
    }


    const instance: StartContactAppointmentSendUpcomingAppointmentReminderRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAppointmentSendUpcomingAppointmentReminderRequest instances
   */
  static deserializeArray(json: string): StartContactAppointmentSendUpcomingAppointmentReminderRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAppointmentSendUpcomingAppointmentReminderRequest instance to a JSON string
   */
  static serialize(instance: StartContactAppointmentSendUpcomingAppointmentReminderRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAppointmentSendUpcomingAppointmentReminderRequest instance to a plain object
   */
  static toObject(instance: StartContactAppointmentSendUpcomingAppointmentReminderRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartContactAppointmentSendUpcomingAppointmentReminderRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAppointmentSendUpcomingAppointmentReminderRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
